import { useId } from 'react';

/**
 * The "Male player" gender chip — green gradient square with a ♂ symbol.
 * Colors are baked in by design (Figma Gender component, variant "Male").
 */
export default function GenderMale({ className }: { className?: string }) {
  const uid = useId().replace(/:/g, '');
  const gradientId = `gender-male-gradient-${uid}`;

  return (
    <svg className={className} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <linearGradient
          id={gradientId}
          x1="16"
          y1="2"
          x2="16"
          y2="30"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#59D88F" />
          <stop offset="1" stopColor="#55CE89" />
        </linearGradient>
      </defs>
      <rect x="2" y="2" width="28" height="28" rx="3.6" fill={`url(#${gradientId})`} />
      <path
        transform="translate(6.33 6.038) scale(1.3332)"
        fill="#FCF2FF"
        d="M10.9336 0C10.5194 0 10.1836 0.335786 10.1836 0.75C10.1836 1.16421 10.5194 1.5 10.9336 1.5H12.1284C12.2172 1.5 12.262 1.6071 12.1996 1.67028L9.75306 4.14697C9.7174 4.18308 9.66041 4.18667 9.61996 4.15603C8.61377 3.39369 7.3597 2.94141 6 2.94141C2.68629 2.94141 0 5.6277 0 8.94141C0 12.2551 2.68629 14.9414 6 14.9414C9.31371 14.9414 12 12.2551 12 8.94141C12 7.59144 11.5542 6.34561 10.8017 5.34311C10.7716 5.30304 10.775 5.24691 10.8102 5.21126L13.1765 2.81571C13.2393 2.75212 13.3477 2.7966 13.3477 2.88599V3.97266C13.3477 4.38687 13.6834 4.72266 14.0977 4.72266C14.5119 4.72266 14.8477 4.38687 14.8477 3.97266V0.75C14.8477 0.335786 14.5119 0 14.0977 0H10.9336ZM6 4.44141C8.48528 4.44141 10.5 6.45613 10.5 8.94141C10.5 11.4267 8.48528 13.4414 6 13.4414C3.51472 13.4414 1.5 11.4267 1.5 8.94141C1.5 6.45613 3.51472 4.44141 6 4.44141Z"
      />
    </svg>
  );
}
